import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { RouterLink } from "@angular/router";
import { ConfigService } from "src/app/servicios/config/config.service";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { NgFor, NgIf } from "@angular/common";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-bloque-carta-director",
  templateUrl: "./bloque-carta-director.component.html",
  styleUrls: ["./bloque-carta-director.component.css"],
  imports: [RouterLink, KebabCasePipe, NgFor, NgIf, SkeletonImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloqueCartaDirectorComponent implements OnInit {
  noticias = [];
  constantesGlobales;

  constructor(
    private readonly noticiasService: NoticiasService,
    private readonly configService: ConfigService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const idSeccionCartaDirector = this.constantesGlobales.idCartaDirector;
    const where = "fecha_publicacion < now() and fecha_publicacion >= now() - INTERVAL 1 DAY";
    firstValueFrom(this.noticiasService.getNoticiasSeccion(idSeccionCartaDirector, 1, "subseccion", where)).then((result) => {
      this.noticias = result;
      this.cd.detectChanges();
    });
  }
}
